import React, { useEffect, useState } from "react";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
function TaskList() {
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(new Date());
  const [preStaff, setPreStaff] = useState([]);
  const [presentStaff, setPresentStaff] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [remark, setRemark] = useState('');
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const getFinalTasks = (tasks, selectedDate) => {
    const normalize = d => {
      const date = new Date(d);
      date.setHours(0, 0, 0, 0);
      return date.getTime();
    };
    const selectedTime = normalize(selectedDate);
    const grouped = {};
    tasks.forEach(task => {
      const key = `${task.sub_history_id}_${task.service_id}_${task.times}`;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(task);
    });
    const finalList = [];
    Object.values(grouped).forEach(group => {
      const sortedGroup = group.sort((a, b) => new Date(b.allocated_on) - new Date(a.allocated_on));
      const sample = sortedGroup[0];
      const recTime = normalize(sample.sub_history_rec_date);
      const endTime = normalize(sample.sub_history_end_date);
      if (selectedTime < recTime || selectedTime > endTime) return;
      const dayEntries = sortedGroup.filter(t => t.type === "day" && normalize(t.allocated_on) === selectedTime);
      if (dayEntries.length > 0) {
        finalList.push(...dayEntries);
        return;
      }
      const validDefault = sortedGroup.find(t => {
        if (t.type !== "default") return false;
        return normalize(t.allocated_on) <= selectedTime;
      });
      if (validDefault) {
        finalList.push(validDefault);
      }
    });
    return finalList;
  };
  const fetchPresentAttendance = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-present-staff");
      const data = res.data;
      setPreStaff(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    // fetchTask();
    fetchPresentAttendance();
  }, []);
  useEffect(() => {
    fetchData();
  }, [date]);

  // const fetchData = async () => {
  //   try {
  //     const [taskRes, attendanceRes] = await Promise.all([
  // Configuration details withheld; supply approved runtime settings. 
  // Configuration details withheld; supply approved runtime settings. 
  //     ]);

  //     // setTasks(taskRes.data);
  //     //    const processedTasks = getFinalTasks(taskRes.data);

  //      const processedTasks = getFinalTasks(taskRes.data, date);

  //      console.log(processedTasks);

  //     setTasks(processedTasks);
  //     setPresentStaff(attendanceRes.data);

  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchData = async () => {
    try {
      const selectedDate = date ? date.getFullYear() + "-" + String(date.getMonth() + 1).padStart(2, "0") + "-" + String(date.getDate()).padStart(2, "0") : null;
      const [taskRes, attendanceRes] = await Promise.all([axios.get("https://api.sweepydo.in/fetch-all-task", {
        params: {
          date: selectedDate
        }
      }), axios.get("https://api.sweepydo.in/fetch-attendence", {
        params: {
          date: selectedDate
        }
      })]);
      const processedTasks = getFinalTasks(taskRes.data, date);
      setTasks(processedTasks);
      setPresentStaff(attendanceRes.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [date]);
  const isToday = selectedDate => {
    const today = new Date();
    return new Date(selectedDate).toDateString() === today.toDateString();
  };

  // const isStaffPresent = (staffId) => {
  //   return presentStaff.some((p) => p.staff_id === staffId);
  // };

  // const isStaffPresent = (staffId) => {
  //   if (!isToday(date)) {
  //     return false;
  //   }

  //   return presentStaff.some((p) => p.staff_id === staffId);
  // };

  const isStaffPresent = staffId => {
    return presentStaff.some(p => p.staff_id === staffId);
  };
  const handleReAllocateStaff = async () => {
    try {
      if (!selectedStaff) {
        alert("Please select staff");
        return;
      }
      const selectedDateTime = new Date(date);
      const now = new Date();
      selectedDateTime.setHours(now.getHours(), now.getMinutes(), now.getSeconds());
      const payload = {
        sub_history_id: selectedRow.sub_history_id,
        service_id: selectedRow.service_id,
        times: selectedRow.times,
        staff_id: selectedStaff,
        type: "day",
        remark: remark,
        allocated_on: selectedDateTime
      };
      await axios.post("https://api.sweepydo.in/reallocate-staff", payload);
      setShowModal(false);
      setSelectedStaff("");
      setRemark("");

      // // ✅ refresh table
      showToast('Staff reallocated successfully!', 'success');
      fetchData();
    } catch (error) {
      console.log(error);
      showToast("Fail to re-allocated staff", 'danger');
    }
  };
  return <div className="container-fluid p-4" style={{
    minHeight: "100vh"
  }}>
       <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />

      <h3 className="text-white mb-4 text-center">Task List</h3>
     
        <div className="d-flex justify-content-center mb-4">
    <div style={{
        background: "var(--black)",
        padding: "15px",
        borderRadius: "12px"
      }}>
      <Calendar onChange={setDate} value={date} prevLabel={null} nextLabel={null} prev2Label={null} next2Label={null} />
    </div>
  </div>


      <div className="card shadow-lg" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
        <div className="card-body">

          <table className="table table-borderless text-white align-middle text-center">
            <thead>
              <tr>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Task Name</th>
                 <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Task Type </th>
                 <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>User Name</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Assigned Staff</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Shift</th>
                 <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Type</th>
                {/* <th style={{ background: "var(--black2)",color:"#fff"}}>Staff Mobile</th> */}
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Allocated On</th>
                <th style={{
                background: "var(--black2)",
                color: "#fff"
              }}>Status</th>
              </tr>
            </thead>

            <tbody>
              {tasks.map((item, i) => <tr key={i}>
                  <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
  {JSON.parse(item.sub_history_service_name || "[]").find(s => s.sId == item.service_id)?.name || item.sub_name}
</td>

              <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
  {JSON.parse(item.sub_history_service_name || "[]").find(s => s.sId == item.service_id)?.s_type || item.s_type}
</td>
                   <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>{item.users_name}<br />{item.users_mobile}</td>

                  <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>

                         {item.staff_name}<br />{item.staff_mobile}
                  </td>
  <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>

                         {item.times}
                  </td>

 <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
               {item.type === "day" ? <span className="badge bg-white text-dark ms-2">
    Reallocated
  </span> : <span className="badge bg-dark ms-2">
    Default
  </span>}
    </td>
                

                  <td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
                    {new Date(item.allocated_on).toLocaleString()}
                  </td>

                

                  {/* <td style={{ background: "var(--black)", color: "#fff" }}>
                   {isStaffPresent(item.staff_id) ? (
                   <span className="badge bg-success px-3 py-2">
                   Present
                   </span>
                   ) : (
                   <>
                   <span className="badge bg-danger me-2 px-3 py-2">
                   Absent
                   </span>
                   {item.type === "default" &&
                   <button
                   className="btn btn-sm btn-primary text-white"
                   onClick={() => {
                   setSelectedRow(item);
                   setShowModal(true);
                   }}
                   >
                   Reassign
                   </button>
                   }
                   </>
                   )}
                   </td> */}


{/* <td style={{ background: "var(--black)", color: "#fff" }}>
  {(() => {
    const serviceData = JSON.parse(item.sub_history_service_name || "[]")
      .find((s) => s.sId == item.service_id);
 
    const sType = serviceData?.s_type || item.s_type;
 
    const isPresent = isStaffPresent(item.staff_id);
 
    const canReassign =
      item.type === "default" ||
      sType === "Monthly" ||
      sType === "Weekly";
 
    return (
      <>
        {isPresent ? (
          <span className="badge bg-success px-3 py-2">
            Present
          </span>
        ) : (
          <span className="badge bg-danger me-2 px-3 py-2">
            Absent
          </span>
        )}
 
 
        {canReassign && (
          <button
            className="btn btn-sm btn-primary text-white ms-2"
            onClick={() => {
              setSelectedRow(item);
              setShowModal(true);
            }}
          >
            Reassign
          </button>
        )}
      </>
    );
  })()}
 </td> */}

<td style={{
                background: "var(--black)",
                color: "#fff"
              }}>
  {(() => {
                  const serviceData = JSON.parse(item.sub_history_service_name || "[]").find(s => s.sId == item.service_id);
                  const sType = serviceData?.s_type || item.s_type;
                  const isPresent = isStaffPresent(item.staff_id);
                  const isReallocated = item.type === "day";
                  const canReassign = !isReallocated && (item.type === "default" || sType === "Monthly" || sType === "Weekly");
                  return <>
        {isPresent ? <span className="badge bg-success px-3 py-2">
            Present
          </span> : <span className="badge bg-danger me-2 px-3 py-2">
            Absent
          </span>}

        {/* Reassign button */}
        {canReassign && <button className="btn btn-sm btn-primary text-white ms-2" onClick={() => {
                      setSelectedRow(item);
                      setShowModal(true);
                    }}>
            Reassign
          </button>}
      </>;
                })()}
</td>


                </tr>)}
            </tbody>

          </table>

        </div>

          {showModal && <div className="modal fade show" style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>

        
        <div className="modal-header border-0">
          <h5 className="modal-title">Assign Staff</h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
        </div>

    
        <div className="modal-body">

      
         <div className="mb-3">
  <label className="form-label">Select Staff</label>
  <select className="form-select" value={selectedStaff} onChange={e => setSelectedStaff(e.target.value)} style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff",
                  border: "1px solid #444"
                }}>
    <option value="">Select</option>

    {preStaff.map(staff => <option key={staff.staff_id} value={staff.staff_id}>
        {staff.staff_name}
      </option>)}
  </select>
</div>

   <div className="mb-3">
    <label className="form-label">Enter Remark</label>
     <input type='text' className="form-control" value={remark} onChange={e => setRemark(e.target.value)} />

    </div>
     
        </div>
        <div className="modal-footer border-0">
          <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Cancel
          </button>

          <button className="btn btn-primary" onClick={handleReAllocateStaff}>
            Save
          </button>
        </div>

      </div>
    </div>
  </div>}
      </div>

    </div>;
}
export default TaskList;
